module.exports = __webpack_public_path__ + "static/media/icons-ic-demo-dm.13b381a9.svg";